/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Barge_DescriptionInputs */



/**
* | output |
* | --- |
* | "European barge inspections under the BIRE and EBIS schemes." |
*
* @param {Service_Barge_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_barge_description = /** @type {((inputs?: Service_Barge_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Barge_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("依据 BIRE 和 EBIS 计划开展的欧洲驳船检查。")
	return /** @type {LocalizedString} */ ("European barge inspections under the BIRE and EBIS schemes.")
});